import React from 'react';

const KolayCRMTerms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Kullanım Koşulları</h1>
      <p className="text-center text-gray-600 mb-4">Son Güncelleme: Mayıs 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Bu Kullanım Koşulları, KolayCRM ("Uygulama") uygulamasını kullanımınızı düzenler.
          Uygulamayı indirerek veya kullanarak bu koşulları kabul etmiş sayılırsınız.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Hizmet Tanımı</h2>
        <p>
          KolayCRM, küçük işletmeler için geliştirilmiş bir müşteri ilişkileri yönetimi (CRM) uygulamasıdır.
          Uygulama; müşteri, ürün/hizmet, satış, tahsilat/borç takibi, randevu ve teklif yönetimi sunar.
          Ayrıca çok kullanıcılı çalışma alanı (workspace) ve rol bazlı veri erişimi sağlar.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Hesap ve Kayıt</h2>
        <p>
          Uygulamayı kullanmak için geçerli bir e-posta adresi ile veya “Apple ile Giriş Yap” kullanarak kayıt olmanız gerekmektedir.
          Hesap bilgilerinizin gizliliğini korumak sizin sorumluluğunuzdadır.
          Hesabınız üzerinden gerçekleştirilen tüm işlemlerden siz sorumlusunuz.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Çalışma Alanı ve Ekip Üyeleri</h2>
        <p>
          Uygulama, bir çalışma alanı sahibinin ekip üyelerini davet kodu ile davet etmesine olanak tanır.
          Üyeler rollerine göre (sahip, yönetici, üye) farklı erişim yetkilerine sahiptir.
          Çalışma alanı sahibi, üyelerin eklenmesi, çıkarılması ve verilerin yönetiminden sorumludur.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Abonelik ve Ödeme</h2>
        <p>
          Uygulama, ücretsiz ve ücretli (Pro) sürümler sunmaktadır:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li><strong>Ücretsiz Sürüm:</strong> Temel CRM özellikleri ve sınırlı kayıt.</li>
          <li><strong>Pro Sürüm:</strong> Sınırsız müşteri/satış kaydı, çok kullanıcılı ekip çalışma alanı, PDF ekstre ve teklif, randevu yönetimi ve tüm premium özellikler.</li>
        </ul>
        <p className="mt-4">
          Pro abonelikler otomatik olarak yenilenir. Aboneliğinizi istediğiniz zaman Apple Ayarları üzerinden iptal edebilirsiniz.
          İptal işlemi, mevcut abonelik döneminin sonunda geçerli olur.
        </p>
        <p>
          Ödeme, satın alma onaylandığında Apple Kimliğinize bağlı ödeme yönteminden tahsil edilir.
          Abonelik, mevcut dönemin bitiminden en az 24 saat önce iptal edilmediği sürece otomatik olarak yenilenir ve
          yenileme ücreti aynı süre içinde hesabınızdan tahsil edilir. Abonelik fiyatları ve süreleri satın alma ekranında belirtilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Kullanım Kuralları</h2>
        <p>
          Uygulamayı kullanırken aşağıdaki kurallara uymayı kabul edersiniz:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Uygulamayı yalnızca yasal amaçlarla kullanmak</li>
          <li>Başkalarının haklarını ihlal etmemek</li>
          <li>Uygulamanın güvenliğini tehlikeye atacak eylemlerden kaçınmak</li>
          <li>Uygulamayı tersine mühendislik yapmamak veya kaynak kodunu çözmeye çalışmamak</li>
          <li>Spam veya zararlı içerik paylaşmamak</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">6. Fikri Mülkiyet</h2>
        <p>
          Uygulama ve içeriği (tasarım, kod, grafikler, logolar) N1İnovasyon'a aittir ve telif hakkı ile korunmaktadır.
          Uygulamayı kullanma hakkı size verilmiştir ancak mülkiyet hakkı devredilmemiştir.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Veri ve Gizlilik</h2>
        <p>
          Kişisel verilerinizin işlenmesi hakkında detaylı bilgi için lütfen{' '}
          <a href="/privacy/kolaycrm" className="text-blue-600 hover:text-blue-800">
            Gizlilik Politikamızı
          </a>{' '}
          inceleyin.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Sorumluluk Sınırlaması</h2>
        <p>
          Uygulama "olduğu gibi" sunulmaktadır. N1İnovasyon, uygulamanın kesintisiz veya hatasız çalışacağını garanti etmez.
          Veri kaybı, iş kaybı veya dolaylı zararlardan N1İnovasyon sorumlu tutulamaz.
        </p>
        <p>
          Kullanıcı, girdiği verilerin doğruluğundan ve yedeklenmesinden kendisi sorumludur.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Hesap Sonlandırma</h2>
        <p>
          Kullanım koşullarını ihlal etmeniz durumunda hesabınız önceden bildirim yapılmaksızın askıya alınabilir veya silinebilir.
          Hesabınızı istediğiniz zaman uygulama içinden veya bizimle iletişime geçerek silebilirsiniz.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. Değişiklikler</h2>
        <p>
          Bu kullanım koşulları zaman zaman güncellenebilir.
          Önemli değişiklikler uygulama içinden veya e-posta yoluyla bildirilecektir.
          Değişikliklerden sonra uygulamayı kullanmaya devam etmeniz, yeni koşulları kabul ettiğiniz anlamına gelir.
        </p>

        <h2 className="text-xl font-semibold mt-8">11. Uygulanacak Hukuk</h2>
        <p>
          Bu koşullar Türkiye Cumhuriyeti kanunlarına tabidir.
          Uyuşmazlıkların çözümünde Antalya Mahkemeleri ve İcra Daireleri yetkilidir.
        </p>

        <h2 className="text-xl font-semibold mt-8">12. İletişim</h2>
        <p>
          Kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            Bu uygulamayı kullanarak yukarıdaki koşulları okuduğunuzu ve kabul ettiğinizi onaylarsınız.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KolayCRMTerms;
